export const DEFAULT_WEB_DATA = {
  title: '',
  accessCode: '',
  projectId: '',
  customDomain: '',
};